import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCursor1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconCursor1"><Path d="M4.97896 2.74473C3.59074 2.25247 2.25247 3.59074 2.74473 4.97896L8.35702 20.8063C8.89212 22.3153 11.005 22.3729 11.6215 20.8952L14.3118 14.4463C14.3371 14.3855 14.3855 14.3371 14.4463 14.3118L20.8952 11.6215C22.3729 11.005 22.3153 8.89213 20.8063 8.35702L4.97896 2.74473Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCursor1;
